/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1Products, createTKT1Product, updateTKT1Product, deleteTKT1Product } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaUpload, FaImage, FaStickyNote } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';
import ImageUploadModal from '../components/ImageUploadModal/ImageUploadModal';

class TKT1Product extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'MID',
    sortOrder: 1,
    search: '',
    status: '',
    rnd1_username: '',
    rnd2_username: '',
    supplier_id: ''
  }

  initShowColumns = {
    MID: true,
    ref_product_mid: true,
    friendly_sku_code: true,
    supplier_sku_code: true,
    supplier_id: true,
    product_name: true,
    product_name_english: true,
    description: true,
    rnd1_username: true,
    rnd2_username: true,
    status: true,
    created_at: true,
    updated_at: true,
    note: true
  }

  initColumnWidths = {
    stt: 60,
    MID: 120,
    ref_product_mid: 150,
    friendly_sku_code: 150,
    supplier_sku_code: 150,
    supplier_id: 120,
    product_name: 200,
    product_name_english: 200,
    description: 250,
    rnd1_username: 120,
    rnd2_username: 120,
    status: 100,
    created_at: 150,
    updated_at: 150,
    note: 200,
    actions: 100
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      showIframeModal: false,
      showImageUploadModal: false,
      showNoteModal: false,
      showDeleteModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedProduct: null,
      selectedNoteData: null,
      isEditMode: false,
      uploadingImages: false,
      uploadedImages: [],
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      createFormData: {
        ref_product_mid: '',
        friendly_sku_code: '',
        supplier_sku_code: '',
        supplier_id: '',
        product_name: '',
        product_name_english: '',
        description: '',
        metadata: {},
        note: '',
        rnd1_username: '',
        rnd2_username: '',
        rnd_data: {},
        status: 'active'
      },
      editFormData: {
        ref_product_mid: '',
        friendly_sku_code: '',
        supplier_sku_code: '',
        supplier_id: '',
        product_name: '',
        product_name_english: '',
        description: '',
        metadata: {},
        note: '',
        rnd1_username: '',
        rnd2_username: '',
        rnd_data: {},
        status: 'active'
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Product - Danh sách sản phẩm';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1Product_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1Product_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1Products(apiQuery);
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_product_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1Product_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1Product_ColumnWidths'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1Products(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1Products(apiQuery);
        })
      }
    }
    
    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillUnmount() {
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1Products(apiQuery);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_product_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Products(apiQuery);
  }

  handleRnd1UsernameChange = (e) => {
    const newQuery = { ...this.state.query, rnd1_username: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_product_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Products(apiQuery);
  }

  handleRnd2UsernameChange = (e) => {
    const newQuery = { ...this.state.query, rnd2_username: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_product_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Products(apiQuery);
  }

  handleSupplierIdChange = (e) => {
    const newQuery = { ...this.state.query, supplier_id: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_product_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Products(apiQuery);
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_product_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Products(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_product_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Products(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1Product_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem('TKT1Product_ColumnWidths');
  }

  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });
    
    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;
    
    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;
    
    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });
      
      document.body.classList.remove('table-resizing');
      
      // Save column widths to localStorage
      localStorage.setItem('TKT1Product_ColumnWidths', JSON.stringify(this.state.columnWidths));
    }
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toLowerCase()) {
      case 'active':
        return 'Hoạt động';
      case 'inactive':
        return 'Không hoạt động';
      case 'suspended':
        return 'Tạm dừng';
      case 'deleted':
        return 'Đã xóa';
      default:
        return status;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (product) => {
    this.setState({
      showViewModal: true,
      selectedProduct: product,
      isEditMode: false
    });
  }

  handleEditClick = (product) => {
    this.setState({
      showEditModal: true,
      selectedProduct: product,
      isEditMode: true,
      editFormData: {
        ref_product_mid: product.ref_product_mid || '',
        friendly_sku_code: product.friendly_sku_code || '',
        supplier_sku_code: product.supplier_sku_code || '',
        supplier_id: product.supplier_id || '',
        product_name: product.product_name || '',
        product_name_english: product.product_name_english || '',
        description: product.description || '',
        metadata: product.metadata || {},
        note: product.note || '',
        rnd1_username: product.rnd1_username || '',
        rnd2_username: product.rnd2_username || '',
        rnd_data: product.rnd_data || {},
        status: product.status || 'active'
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedProduct: null,
      isEditMode: false
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      createFormData: {
        ref_product_mid: '',
        friendly_sku_code: '',
        supplier_sku_code: '',
        supplier_id: '',
        product_name: '',
        product_name_english: '',
        description: '',
        metadata: {},
        note: '',
        rnd1_username: '',
        rnd2_username: '',
        rnd_data: {},
        status: 'active'
      }
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedProduct: null,
      isEditMode: false,
      editFormData: {
        ref_product_mid: '',
        friendly_sku_code: '',
        supplier_sku_code: '',
        supplier_id: '',
        product_name: '',
        product_name_english: '',
        description: '',
        metadata: {},
        note: '',
        rnd1_username: '',
        rnd2_username: '',
        rnd_data: {},
        status: 'active'
      }
    });
  }

  // Note modal handlers
  handleNoteClick = (product) => {
    this.setState({
      showNoteModal: true,
      selectedNoteData: {
        MID: product.MID,
        product_name: product.product_name,
        product_name_english: product.product_name_english,
        note: product.note
      }
    });
  }

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      selectedNoteData: null
    });
  }

  // Helper function to truncate note text
  truncateNote = (note, maxLength = 50) => {
    if (!note || note.length <= maxLength) {
      return note;
    }
    return note.substring(0, maxLength) + '...';
  }

  handleCreateInputChange = (field, value) => {
    this.setState({
      createFormData: {
        ...this.state.createFormData,
        [field]: value
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleCreateProduct = async () => {
    const { createFormData } = this.state;
    
    // Validation
    if (!createFormData.product_name) {
      alert('Vui lòng nhập tên sản phẩm');
      return;
    }

    try {
      // Call create action
      await this.props.createTKT1Product(createFormData);
      
      // Close modal
      this.handleCloseCreateModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Products(apiQuery);
      
      alert('Tạo sản phẩm mới thành công!');
    } catch (error) {
      console.error('Error creating product:', error);
      alert('Lỗi khi tạo sản phẩm mới. Vui lòng thử lại.');
    }
  }

  handleSaveEdit = async () => {
    const { selectedProduct, editFormData } = this.state;
    
    if (!selectedProduct || !selectedProduct._id) {
      alert('Không tìm thấy thông tin sản phẩm để cập nhật');
      return;
    }

    try {
      // Call update action
      await this.props.updateTKT1Product(selectedProduct._id, editFormData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Products(apiQuery);
      
      alert('Cập nhật thông tin sản phẩm thành công!');
    } catch (error) {
      console.error('Error updating product:', error);
      alert('Lỗi khi cập nhật thông tin sản phẩm. Vui lòng thử lại.');
    }
  }

  // Delete product handlers
  handleDeleteClick = (product) => {
    this.setState({
      showDeleteModal: true,
      selectedProduct: product
    });
  }

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      selectedProduct: null
    });
  }

  handleConfirmDelete = async () => {
    const { selectedProduct } = this.state;
    
    if (!selectedProduct || !selectedProduct._id) {
      alert('Không tìm thấy thông tin sản phẩm để xóa');
      return;
    }

    try {
      // Call delete action
      await this.props.deleteTKT1Product(selectedProduct._id);
      
      // Close modal
      this.handleCloseDeleteModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Products(apiQuery);
      
      alert('Xóa sản phẩm thành công!');
    } catch (error) {
      console.error('Error deleting product:', error);
      alert('Lỗi khi xóa sản phẩm. Vui lòng thử lại.');
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, status, rnd1_username, rnd2_username, supplier_id, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    // Add R&D username filters if selected
    if (rnd1_username && rnd1_username.trim()) {
      apiQuery.rnd1_username = rnd1_username;
    }
    
    if (rnd2_username && rnd2_username.trim()) {
      apiQuery.rnd2_username = rnd2_username;
    }
    
    // Add supplier filter if selected
    if (supplier_id && supplier_id.trim()) {
      apiQuery.supplier_id = supplier_id;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage
    localStorage.setItem('tkt1_product_query', JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1Products(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1Products(apiQuery);
    localStorage.setItem('tkt1_product_query', JSON.stringify(trimmedQuery));
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    const pathname = '/admin/rnd/tkt1-product';
    history.push({
      pathname: pathname,
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ products: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1Products(apiQuery);
        localStorage.setItem('tkt1_product_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên sản phẩm, MID, SKU..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="active">Hoạt động</option>
              <option value="inactive">Không hoạt động</option>
              <option value="suspended">Tạm dừng</option>
              <option value="deleted">Đã xóa</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>R&D 1</InputGroup.Text>
            <Form.Control
              type="text"
              value={this.state.query.rnd1_username}
              onChange={this.handleRnd1UsernameChange}
              placeholder="Username R&D 1"
            />
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>R&D 2</InputGroup.Text>
            <Form.Control
              type="text"
              value={this.state.query.rnd2_username}
              onChange={this.handleRnd2UsernameChange}
              placeholder="Username R&D 2"
            />
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="MID">MID</option>
              <option value="product_name">Tên sản phẩm</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="rnd1_username">R&D 1</option>
              <option value="rnd2_username">R&D 2</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderProductTable = () => {
    const { products } = this.props;
    const { showColumns, columnWidths } = this.state;
    
    // Ensure products is an array and filter out any null/undefined items
    const safeProducts = Array.isArray(products) ? products.filter(product => product != null && typeof product === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeProducts || safeProducts.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
                STT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
                />
              </th>
              {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
                MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
                />
              </th>}
              {showColumns.ref_product_mid && <th style={{ width: `${columnWidths.ref_product_mid}px`, position: 'relative' }}>
                Ref Product MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'ref_product_mid')}
                />
              </th>}
              {showColumns.friendly_sku_code && <th style={{ width: `${columnWidths.friendly_sku_code}px`, position: 'relative' }}>
                Friendly SKU
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'friendly_sku_code')}
                />
              </th>}
              {showColumns.supplier_sku_code && <th style={{ width: `${columnWidths.supplier_sku_code}px`, position: 'relative' }}>
                Supplier SKU
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'supplier_sku_code')}
                />
              </th>}
              {showColumns.supplier_id && <th style={{ width: `${columnWidths.supplier_id}px`, position: 'relative' }}>
                Supplier ID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'supplier_id')}
                />
              </th>}
              {showColumns.product_name && <th style={{ width: `${columnWidths.product_name}px`, position: 'relative' }}>
                Tên sản phẩm
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'product_name')}
                />
              </th>}
              {showColumns.product_name_english && <th style={{ width: `${columnWidths.product_name_english}px`, position: 'relative' }}>
                Tên tiếng Anh
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'product_name_english')}
                />
              </th>}
              {showColumns.description && <th style={{ width: `${columnWidths.description}px`, position: 'relative' }}>
                Mô tả
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'description')}
                />
              </th>}
              {showColumns.rnd1_username && <th style={{ width: `${columnWidths.rnd1_username}px`, position: 'relative' }}>
                R&D 1
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'rnd1_username')}
                />
              </th>}
              {showColumns.rnd2_username && <th style={{ width: `${columnWidths.rnd2_username}px`, position: 'relative' }}>
                R&D 2
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'rnd2_username')}
                />
              </th>}
              {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'status')}
                />
              </th>}
              {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
                Ngày tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                />
              </th>}
              {showColumns.updated_at && <th style={{ width: `${columnWidths.updated_at}px`, position: 'relative' }}>
                Ngày cập nhật
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'updated_at')}
                />
              </th>}
              {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
                Ghi chú
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'note')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
              STT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
              />
            </th>
            {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
              MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
              />
            </th>}
            {showColumns.ref_product_mid && <th style={{ width: `${columnWidths.ref_product_mid}px`, position: 'relative' }}>
              Ref Product MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'ref_product_mid')}
              />
            </th>}
            {showColumns.friendly_sku_code && <th style={{ width: `${columnWidths.friendly_sku_code}px`, position: 'relative' }}>
              Friendly SKU
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'friendly_sku_code')}
              />
            </th>}
            {showColumns.supplier_sku_code && <th style={{ width: `${columnWidths.supplier_sku_code}px`, position: 'relative' }}>
              Supplier SKU
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'supplier_sku_code')}
              />
            </th>}
            {showColumns.supplier_id && <th style={{ width: `${columnWidths.supplier_id}px`, position: 'relative' }}>
              Supplier ID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'supplier_id')}
              />
            </th>}
            {showColumns.product_name && <th style={{ width: `${columnWidths.product_name}px`, position: 'relative' }}>
              Tên sản phẩm
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'product_name')}
              />
            </th>}
            {showColumns.product_name_english && <th style={{ width: `${columnWidths.product_name_english}px`, position: 'relative' }}>
              Tên tiếng Anh
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'product_name_english')}
              />
            </th>}
            {showColumns.description && <th style={{ width: `${columnWidths.description}px`, position: 'relative' }}>
              Mô tả
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'description')}
              />
            </th>}
            {showColumns.rnd1_username && <th style={{ width: `${columnWidths.rnd1_username}px`, position: 'relative' }}>
              R&D 1
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'rnd1_username')}
              />
            </th>}
            {showColumns.rnd2_username && <th style={{ width: `${columnWidths.rnd2_username}px`, position: 'relative' }}>
              R&D 2
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'rnd2_username')}
              />
            </th>}
            {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'status')}
              />
            </th>}
            {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
              Ngày tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
              />
            </th>}
            {showColumns.updated_at && <th style={{ width: `${columnWidths.updated_at}px`, position: 'relative' }}>
              Ngày cập nhật
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'updated_at')}
              />
            </th>}
            {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
              Ghi chú
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'note')}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeProducts.map((product, index) => {
            if (!product || typeof product !== 'object') return null;
              
              return (
                <tr key={product._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.MID && (
                    <td>
                      {product.MID ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{product.MID}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(product.MID)}
                            title="Copy MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_product_mid && (
                    <td>
                      {product.ref_product_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{product.ref_product_mid}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(product.ref_product_mid)}
                            title="Copy Ref Product MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.friendly_sku_code && (
                    <td>
                      {product.friendly_sku_code ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{product.friendly_sku_code}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(product.friendly_sku_code)}
                            title="Copy Friendly SKU"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.supplier_sku_code && (
                    <td>
                      {product.supplier_sku_code ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{product.supplier_sku_code}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(product.supplier_sku_code)}
                            title="Copy Supplier SKU"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.supplier_id && (
                    <td>
                      {product.supplier_id || '-'}
                    </td>
                  )}
                  {showColumns.product_name && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={product.product_name}>
                        {product.product_name || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.product_name_english && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={product.product_name_english}>
                        {product.product_name_english || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.description && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={product.description}>
                        {product.description || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.rnd1_username && (
                    <td>
                      {product.rnd1_username || '-'}
                    </td>
                  )}
                  {showColumns.rnd2_username && (
                    <td>
                      {product.rnd2_username || '-'}
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {product.status ? (
                        <Badge 
                          bg={
                            product.status === 'active' ? 'success' :
                            product.status === 'inactive' ? 'warning' :
                            product.status === 'suspended' ? 'info' :
                            product.status === 'deleted' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(product.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>
                      {product.created_at ? 
                        new Date(product.created_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.updated_at && (
                    <td>
                      {product.updated_at ? 
                        new Date(product.updated_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      {product.note ? (
                        <div className="d-flex align-items-center gap-2">
                          <span 
                            style={{ 
                              whiteSpace: 'nowrap',
                              cursor: product.note.length > 100 ? 'pointer' : 'default'
                            }}
                            title={product.note}
                          >
                            {this.truncateNote(product.note)}
                          </span>
                          {product.note.length > 100 && (
                            <FaStickyNote 
                              size={12} 
                              style={{ 
                                cursor: 'pointer', 
                                color: '#6c757d',
                                flexShrink: 0
                              }}
                              onClick={() => this.handleNoteClick(product)}
                              title="Xem đầy đủ ghi chú"
                            />
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(product)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(product)}
                      />
                      <FaTrash 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#dc3545'
                        }}
                        title="Xóa sản phẩm"
                        onClick={() => this.handleDeleteClick(product)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    const { columnWidths } = this.state;
    
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Product - Danh sách sản phẩm
              </h2>
            </Col>
            <Col className="text-end">
              <Button 
                variant="success" 
                onClick={() => this.setState({ showCreateModal: true })}
                className="me-2"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm sản phẩm mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
              {this.renderProductTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    MID: 'MID',
                    ref_product_mid: 'Ref Product MID',
                    friendly_sku_code: 'Friendly SKU',
                    supplier_sku_code: 'Supplier SKU',
                    supplier_id: 'Supplier ID',
                    product_name: 'Tên sản phẩm',
                    product_name_english: 'Tên tiếng Anh',
                    description: 'Mô tả',
                    rnd1_username: 'R&D 1',
                    rnd2_username: 'R&D 2',
                    status: 'Trạng thái',
                    created_at: 'Ngày tạo',
                    updated_at: 'Ngày cập nhật',
                    note: 'Ghi chú'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin sản phẩm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedProduct && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedProduct.MID}
                      </Badge>
                      {this.state.selectedProduct.MID && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedProduct.MID)}
                          title="Copy MID"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ref Product MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedProduct.ref_product_mid || '-'}</span>
                      {this.state.selectedProduct.ref_product_mid && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedProduct.ref_product_mid)}
                          title="Copy Ref Product MID"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Friendly SKU:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedProduct.friendly_sku_code || '-'}</span>
                      {this.state.selectedProduct.friendly_sku_code && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedProduct.friendly_sku_code)}
                          title="Copy Friendly SKU"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Supplier SKU:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedProduct.supplier_sku_code || '-'}</span>
                      {this.state.selectedProduct.supplier_sku_code && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedProduct.supplier_sku_code)}
                          title="Copy Supplier SKU"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên sản phẩm:</strong> 
                    <div className="mt-1">
                      {this.state.selectedProduct.product_name || '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên tiếng Anh:</strong> 
                    <div className="mt-1">
                      {this.state.selectedProduct.product_name_english || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* R&D Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin R&D</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>R&D 1 Username:</strong> 
                    <div className="mt-1">
                      {this.state.selectedProduct.rnd1_username || '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>R&D 2 Username:</strong> 
                    <div className="mt-1">
                      {this.state.selectedProduct.rnd2_username || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedProduct.status ? (
                        <Badge 
                          bg={
                            this.state.selectedProduct.status === 'active' ? 'success' :
                            this.state.selectedProduct.status === 'inactive' ? 'warning' :
                            this.state.selectedProduct.status === 'suspended' ? 'info' :
                            this.state.selectedProduct.status === 'deleted' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedProduct.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bổ sung</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Mô tả:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedProduct.description || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedProduct.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm sản phẩm mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên sản phẩm <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.product_name}
                      onChange={(e) => this.handleCreateInputChange('product_name', e.target.value)}
                      placeholder="Nhập tên sản phẩm"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên tiếng Anh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.product_name_english}
                      onChange={(e) => this.handleCreateInputChange('product_name_english', e.target.value)}
                      placeholder="Nhập tên tiếng Anh"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ref Product MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.ref_product_mid}
                      onChange={(e) => this.handleCreateInputChange('ref_product_mid', e.target.value)}
                      placeholder="Nhập Ref Product MID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Supplier ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.supplier_id}
                      onChange={(e) => this.handleCreateInputChange('supplier_id', e.target.value)}
                      placeholder="Nhập Supplier ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Friendly SKU Code</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.friendly_sku_code}
                      onChange={(e) => this.handleCreateInputChange('friendly_sku_code', e.target.value)}
                      placeholder="Nhập Friendly SKU Code"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Supplier SKU Code</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.supplier_sku_code}
                      onChange={(e) => this.handleCreateInputChange('supplier_sku_code', e.target.value)}
                      placeholder="Nhập Supplier SKU Code"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>R&D 1 Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.rnd1_username}
                      onChange={(e) => this.handleCreateInputChange('rnd1_username', e.target.value)}
                      placeholder="Nhập R&D 1 Username"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>R&D 2 Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.rnd2_username}
                      onChange={(e) => this.handleCreateInputChange('rnd2_username', e.target.value)}
                      placeholder="Nhập R&D 2 Username"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.status}
                      onChange={(e) => this.handleCreateInputChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                      <option value="suspended">Tạm dừng</option>
                      <option value="deleted">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.createFormData.description}
                      onChange={(e) => this.handleCreateInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả sản phẩm"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.createFormData.note}
                      onChange={(e) => this.handleCreateInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleCreateProduct}>
              <i className="fas fa-plus me-1"></i>
              Tạo sản phẩm mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa sản phẩm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên sản phẩm</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.product_name}
                      onChange={(e) => this.handleEditInputChange('product_name', e.target.value)}
                      placeholder="Nhập tên sản phẩm"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên tiếng Anh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.product_name_english}
                      onChange={(e) => this.handleEditInputChange('product_name_english', e.target.value)}
                      placeholder="Nhập tên tiếng Anh"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ref Product MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_product_mid}
                      onChange={(e) => this.handleEditInputChange('ref_product_mid', e.target.value)}
                      placeholder="Nhập Ref Product MID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Supplier ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.supplier_id}
                      onChange={(e) => this.handleEditInputChange('supplier_id', e.target.value)}
                      placeholder="Nhập Supplier ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Friendly SKU Code</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.friendly_sku_code}
                      onChange={(e) => this.handleEditInputChange('friendly_sku_code', e.target.value)}
                      placeholder="Nhập Friendly SKU Code"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Supplier SKU Code</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.supplier_sku_code}
                      onChange={(e) => this.handleEditInputChange('supplier_sku_code', e.target.value)}
                      placeholder="Nhập Supplier SKU Code"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>R&D 1 Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.rnd1_username}
                      onChange={(e) => this.handleEditInputChange('rnd1_username', e.target.value)}
                      placeholder="Nhập R&D 1 Username"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>R&D 2 Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.rnd2_username}
                      onChange={(e) => this.handleEditInputChange('rnd2_username', e.target.value)}
                      placeholder="Nhập R&D 2 Username"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                      <option value="suspended">Tạm dừng</option>
                      <option value="deleted">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.description}
                      onChange={(e) => this.handleEditInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả sản phẩm"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Note Modal */}
        <Modal show={this.state.showNoteModal} onHide={this.handleCloseNoteModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Ghi chú chi tiết</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNoteData && (
              <div>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.MID}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên sản phẩm:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNoteData.product_name || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Tên tiếng Anh:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNoteData.product_name_english || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-2 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedNoteData.note || 'Không có ghi chú'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseNoteModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={this.state.showDeleteModal} onHide={this.handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Xác nhận xóa sản phẩm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedProduct && (
              <div>
                <p>Bạn có chắc chắn muốn xóa sản phẩm này không?</p>
                <div className="alert alert-warning" role="alert">
                  <strong>MID:</strong> {this.state.selectedProduct.MID}<br/>
                  <strong>Tên sản phẩm:</strong> {this.state.selectedProduct.product_name || 'N/A'}<br/>
                  <strong>Tên tiếng Anh:</strong> {this.state.selectedProduct.product_name_english || 'N/A'}
                </div>
                <p className="text-danger">
                  <strong>Cảnh báo:</strong> Hành động này không thể hoàn tác!
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
              Hủy
            </Button>
            <Button variant="danger" onClick={this.handleConfirmDelete}>
              <FaTrash size={14} className="me-1" />
              Xóa sản phẩm
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.tkt1ProductReducer.products,
    totalCount: state.tkt1ProductReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1Products, createTKT1Product, updateTKT1Product, deleteTKT1Product })(TKT1Product);
